export default __webpack_public_path__ + "static/media/loading.3e0a46fc.svg";